import LoadingView from 'components/LoadingView';
import { setUserId } from 'components/RootView/missionExplorerSlice';
import { IUser } from 'components/general/types/general';
import { GENERIC_ERROR_MESSAGE } from 'config';
import { useSnackbar } from 'hooks';
import { SatelliteApi } from 'middleware/SatelliteApi/api';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import Routes, { useSearchParams } from 'routes';

/**
 * Component to handle the redirect from the SSO provider and pass along the appropriate values to the API
 */
const SsoRedirect = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [searchParams] = useSearchParams();
  const {
    User: {
      actions: { finishExternalAuth, getUser, setProfileIncomplete, finishExternalPatch },
    },
  } = SatelliteApi;

  useEffect(() => {
    if (!searchParams.code) {
      history.replace(Routes.ROOT());
    }

    const isPatch = history.location.pathname.includes(Routes.SSO_PATCH());
    const apiCall = isPatch ? finishExternalPatch : finishExternalAuth;
    const back = isPatch ? Routes.ACCOUNT() : Routes.SSO_LOGIN();

    const failureMessage = `${GENERIC_ERROR_MESSAGE} If you're logging in with an existing account, please double check that you've used the correct credentials.`;

    dispatch(
      apiCall({
        // TODO: This is Entra specific, need to make it generic when we add more identity providers
        code: searchParams.code,
        successCallback: () => {
          // Cookie has been set, now we can get the user
          dispatch(
            getUser({
              successCallback: (user: IUser) => {
                dispatch(setUserId(user.id));
                if (isPatch) {
                  // If this is a patch instead of a signup, artificially mark the user incomplete
                  // so they can "complete their profile" again
                  dispatch(
                    setProfileIncomplete({
                      id: user.id,
                      incomplete: true,
                    })
                  );
                }
                history.replace(Routes.SSO_SIGNUP());
              },
              failureCallback: () => {
                history.replace(back);
                enqueueSnackbar(failureMessage, { variant: 'error' });
              },
            })
          );
        },
        failureCallback: () => {
          enqueueSnackbar(failureMessage, { variant: 'error' });
          history.replace(back);
        },
      })
    );
  }, [
    dispatch,
    history,
    searchParams,
    finishExternalAuth,
    getUser,
    enqueueSnackbar,
    setProfileIncomplete,
    finishExternalPatch,
  ]);

  return <LoadingView />;
};

export default withRouter(SsoRedirect);
